(function ($) {
  let state = false;
  const $password = $('.password-check').length
    ? $('.password-check')
    : $('[name="account_password"]');
  const $passwordStrength = $('#password-strength');
  const lowUpperCase = $('.low-upper-case');
  const number = $('.one-number');
  const specialChar = $('.one-special-char');
  const eightChar = $('.eight-character');
  const $popupPassword = $('.popover-password');
  const $showPassword = $('.show-password-btn');
  const $legendPassword = $('.popover-password__legend');

  $showPassword.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (state) {
      $password.attr('type', 'password');
      $showPassword.removeClass('show-password-btn--clicked');
      state = false;
    } else {
      $password.attr('type', 'text');
      $showPassword.addClass('show-password-btn--clicked');
      state = true;
    }
  });

  if (!$password.length) {
    return;
  }

  $password.on('focus', function () {
    $popupPassword.addClass('popover-password--show');
  });

  $password.on('blur', function () {
    $popupPassword.removeClass('popover-password--show');
  });

  $password.on('keyup', function () {
    checkStrength($password.val());
  });

  /**
   *
   */
  function checkStrength(password) {
    let strength = 0;

    // If password contains both lower and uppercase characters
    if (/([a-z].*[A-Z])|([A-Z].*[a-z])/.test(password)) {
      strength += 1;
      lowUpperCase.addClass('pass-ok');
    } else {
      lowUpperCase.removeClass('pass-ok');
    }
    // If it has numbers and characters
    if (/([0-9])/.test(password)) {
      strength += 1;
      number.addClass('pass-ok');
    } else {
      number.removeClass('pass-ok');
    }

    // If password is greater than 7
    if (password.length > 7) {
      strength += 2;
      eightChar.addClass('pass-ok');
    } else {
      eightChar.removeClass('pass-ok');
    }

    // If value is less than 2
    if (strength < 1) {
      $passwordStrength.css('transform', 'scaleX(0)');
    } else if (strength < 2) {
      $passwordStrength.removeClass(
        'progress-password__bar-success progress-password__bar-warning',
      );
      $passwordStrength.addClass('progress-password__bar-danger');
      $passwordStrength.css('transform', 'scaleX(0.1)');
    } else if (strength == 3) {
      $passwordStrength.removeClass('progress-password__bar-danger progress-password__bar-success');
      $passwordStrength.addClass('progress-password__bar-warning');
      $passwordStrength.css('transform', 'scaleX(0.6)');
    }

    if (strength == 4) {
      $password;
      $legendPassword.hide();
      $password.addClass('password-is-strong');
      $password.removeClass('parsley-error');
      $passwordStrength.removeClass('progress-password__bar-danger progress-password__bar-warning');
      $passwordStrength.addClass('progress-password__bar-success');
      $passwordStrength.css('transform', 'scaleX(1)');
    } else {
      $legendPassword.show();
      $password.removeClass('password-is-strong');
      $password.addClass('parsley-error');
    }
  }
})(jQuery);
